import request from '@/apis/request'
const resource = 'agent-banks' 

export default {
  get: (params = {}) => {
    return request.get(`${resource}`, { params })
  }, 
}